'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _restaurantsFacebookProxyClient = require('@wix/restaurants-facebook-proxy-client');

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromisedFB = function () {
    function PromisedFB(FB) {
        (0, _classCallCheck3.default)(this, PromisedFB);

        this._FB = FB;
    }

    // Promisify the FB.api call


    (0, _createClass3.default)(PromisedFB, [{
        key: 'api',
        value: function api(path, params) {
            var deferredApi = _q2.default.defer();
            this._FB.api(path, params, function (response) {
                deferredApi.resolve(response);
            });
            return deferredApi.promise;
        }
    }, {
        key: 'getAuthResponse',
        value: function getAuthResponse() {
            return this._FB.getAuthResponse();
        }
    }, {
        key: 'getLoginStatus',
        value: function getLoginStatus() {
            var deferred = _q2.default.defer();
            this._FB.getLoginStatus(function (rc) {
                deferred.resolve(rc);
            });
            return deferred.promise;
        }
    }, {
        key: 'isDefined',
        value: function isDefined() {
            return !!this._FB;
        }
    }]);
    return PromisedFB;
}();

function isLoggedInLocally(promisedFB) {
    // If no FB loaded, go straight to the proxy
    if (!promisedFB.isDefined()) {
        return (0, _q2.default)(false);
    }

    // Already logged in? (getAuthResponse is a synchronous call)
    var authResponse = promisedFB.getAuthResponse();
    if (authResponse && authResponse.accessToken) {
        return (0, _q2.default)(true);
    } else {
        // See if it's not just stale?
        return promisedFB.getLoginStatus().then(function (response) {
            return (0, _q2.default)(response.status === 'connected');
        });
    }
}

exports.default = function (path, params) {
    var promisedFB = new PromisedFB(FB);
    var remoteFB = new _restaurantsFacebookProxyClient.FacebookProxyClient({ XMLHttpRequest: XMLHttpRequest });
    return isLoggedInLocally(promisedFB).then(function (isLoggedIn) {
        if (isLoggedIn) {
            return promisedFB.api(path, params);
        } else {
            return remoteFB.api({ path: path, params: params });
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/FacebookApiConnector.js
// module id = 979
// module chunks = 0